export default __webpack_public_path__ + "static/media/store-item-manager.fca2c99b.png";